import { ElButton, ElCard, ElRadioGroup, ElRadio, ElTable, ElTableColumn, ElCheckbox, ElMessage, ElProgress, /* otros componentes que necesites */ } from 'element-plus';
import 'element-plus/dist/index.css';

export default (app) => {
  app.component(ElProgress.name, ElProgress);
  app.component(ElButton.name, ElButton);
  app.component(ElCard.name, ElCard);
  app.component(ElTable.name, ElTable); 
  app.component(ElTableColumn.name, ElTableColumn);
  app.component(ElRadioGroup.name, ElRadioGroup);
  app.component(ElRadio.name, ElRadio);
  app.component(ElCheckbox.name, ElCheckbox);
  app.config.globalProperties.$message = ElMessage;
  // Registra otros componentes si es necesario
};


